export const user_fake_claims = {
    "home" : "1",
    "mrp": "1",
    "deterministic-mrp": "1",
    "cms": "1",
    "cell-formation-problem": "1",
    "routing": "1",
    "order": "1",
    "assignment": "1",
};